<div class="grid-container padding-y-4">
    <div class="grid-row">
        <div class="col-12">
            <legend class="usa-legend usa-legend--large">GSA 3080 File Upload</legend>
        </div>
    </div>
    <app-upload [businessType]="'survey'"></app-upload>
</div>